"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bootstrap = void 0;

var _initializeAxios = require("@insided/shared/bootstrap/initializeAxios");

var _initializeGlobals = require("./initializeGlobals");

var _polyfills = require("@insided/shared/polyfills");

var _bootstrap = require("@insided/shared/bootstrap");

var _initializeTracking = require("./initializeTracking");

var _initializeApp = require("./initializeApp");

var _detectLogout = _interopRequireDefault(require("@insided/deprecated-utils/detectLogout"));

var _chWebSdk = require("./ch-web-sdk");

var bootstrap = function bootstrap() {
  // Initialize external SDK
  (0, _chWebSdk.initChWebSdk)(); // Initialize core services

  (0, _initializeAxios.initializeAxios)();
  (0, _detectLogout.default)();
  (0, _polyfills.initializePolyfills)();
  (0, _initializeGlobals.initializeGlobals)(); // Initialize features

  (0, _initializeTracking.initializeTracking)();
  (0, _bootstrap.initializeUrlNavigation)(); // Initialize app

  (0, _initializeApp.initializeApp)(); // Notify web components that insided is ready

  document.dispatchEvent(new CustomEvent('insidedReady'));
};

exports.bootstrap = bootstrap;